import React, { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";

function ForgotPassword() {
  const auth = getAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Password reset email sent! Please check your inbox.");
      setTimeout(() => navigate("/"), 3000);
    } catch (err) {
      setMessage(err.message);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="vi-forgot-container">
      {/* Left Panel - Visual Guidance */}
      <div className="vi-forgot-visual">
        <div className="vi-forgot-illustration">
          <div className="vi-forgot-animation" aria-hidden="true">
            <div className="vi-email-icon">✉️</div>
            <div className="vi-arrow-animation"></div>
            <div className="vi-user-icon">👤</div>
          </div>
        </div>
        <div className="vi-forgot-visual-text">
          <h1 className="vi-forgot-main-title">Reaching To Unreach</h1>
          <p className="vi-forgot-subtitle">Visual Impairment Support System</p>
        </div>
      </div>

      {/* Right Panel - Form */}
      <div className="vi-forgot-form-container">
        <div className="vi-forgot-card">
          <h2 className="vi-forgot-title">Reset Your Password</h2>
          <p className="vi-forgot-description">
            Enter your email address and we'll send you instructions to reset your password.
          </p>

          <form onSubmit={handleSubmit} className="vi-forgot-form">
            <div className="vi-input-group">
              <label htmlFor="vi-email" className="vi-input-label">Email Address</label>
              <input
                id="vi-email"
                type="email"
                name="email"
                className="vi-form-input"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                aria-required="true"
              />
            </div>

            <button 
              type="submit" 
              className="vi-reset-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span className="vi-spinner">Sending...</span>
              ) : (
                "Send Reset Link"
              )}
            </button>

            {message && (
              <div className={`vi-message ${message.includes("sent") ? "success" : "error"}`}>
                {message}
              </div>
            )}

            <div className="vi-back-to-login">
              Remember your password?{" "}
              <button 
                type="button" 
                className="vi-text-button"
                onClick={() => navigate("/")}
              >
                Sign in
              </button>
            </div>
          </form>


        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;